export default {
      id: "flag-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite-46b249.svg#flag-usage",
      toString: function () {
        return this.url;
      }
    }